// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","logo":"header_logo__UESgy"};